import { FeedbackState } from "../Constants/feedbackEnums";

interface IFeedbackStateService {
  getDisplayNameForState: (state: FeedbackState) => string;
}

class FeedbackStateService implements IFeedbackStateService {
  getDisplayNameForState(state: FeedbackState): string {
    switch (state) {
      case FeedbackState.InDevelopment:
        return "In Development";
      case FeedbackState.CannotReproduce:
        return "Cannot Reproduce";
      case FeedbackState.NotApplicable:
        return "Not Applicable";
      case FeedbackState.PendingReview:
        return "Pending Review";
      case FeedbackState.ReadyForDev:
        return "Ready for Dev";
      default:
        return state.toString();
    }
  }
}

export const feedbackStateService = new FeedbackStateService();
